import type { EventsIndexParams, EventItem, EventCreateUpdateResponse } from '../types/events';
import { wrapFetch } from '../libs/fetch';
import { EventData, RelatedEvent, RelatedRecruitment } from '../types/eventDetail';

export const fetchEvents = async (params?: EventsIndexParams): Promise<{ event_ids: number[] }> => {
  const searchParams = new URLSearchParams();
  if (params) {
    if (params.q) searchParams.append('q', params.q);
    if (params.page) searchParams.append('page', params.page.toString());
    if (params.companyId) searchParams.append('company_id', params.companyId.toString());
  }
  const queryString = searchParams.toString();
  const url = queryString ? `/api/v1/events?${queryString}` : '/api/v1/events';
  return await wrapFetch<{ event_ids: number[] }>(url);
};

export const getShowEvent = async (eventId: number): Promise<EventItem> => {
  return await wrapFetch<EventItem>(`/api/v1/events/${eventId}/show_event`);
};

export const getEventDetail = async (eventId: number, isPreview?: boolean): Promise<EventData> => {
  const url = isPreview ? `/api/v1/events/${eventId}?preview=true` : `/api/v1/events/${eventId}`;
  return await wrapFetch<EventData>(url);
};

export const getRelatedRecruitments = async (eventId: number) => {
  return await wrapFetch<{ recruitments: RelatedRecruitment[] }>(`/api/v1/events/${eventId}/related_recruitments`);
};

export const getRelatedEvents = async (eventId: number) => {
  return wrapFetch<{ events: RelatedEvent[] }>(`/api/v1/events/${eventId}/related_events`);
};

export const getEditForm = async (eventId: number) => {
  return await wrapFetch<any>(`/api/v1/events/${eventId}/edit_form`);
};

export const createEvent = async (form: FormData, csrfToken: string): Promise<EventCreateUpdateResponse> => {
  return await wrapFetch<EventCreateUpdateResponse>('/api/v1/events', {
    method: 'POST',
    headers: {
      'X-CSRF-Token': csrfToken,
    },
    body: form,
    credentials: 'same-origin',
  });
};

export const updateEvent = async (eventId: number, form: FormData, csrfToken: string): Promise<EventCreateUpdateResponse> => {
  return await wrapFetch<EventCreateUpdateResponse>(`/api/v1/events/${eventId}`, {
    method: 'PATCH',
    headers: {
      'X-CSRF-Token': csrfToken,
    },
    body: form,
    credentials: 'same-origin',
  });
};
